import { Component, Fragment } from 'react';
import {
  modifyKYCActionCard,
  pendingKYCActionCard,
  pendingMandateActionCard,
  pendingPennyDropCard,
} from '../../../constants';
import '../../../styles/home/home.scss';
import CarousalCard from '../../home/carousalCard';
import DashboardCard from '../../home/dashboardCard';

class BannerOne extends Component<any, any> {
  public getCarousalCards = () => {
    const { pendingActions } = this.props;
    const arr = [];
    pendingActions.map((item) => {
      if (item === 'KYC') {
        // If user modify the KYC, then we will get both flag in pending action, else it will be kyc pending case
        if (pendingActions.includes('KYC_MODIFICATION')) {
          arr.push(modifyKYCActionCard);
        } else {
          arr.push(pendingKYCActionCard);
        }
      } else if (item === 'MANDATE_DIRECT') {
        // Check mandate for direct only.
        arr.push(pendingMandateActionCard);
      } else if (item === 'PENNY_DROP_PENDING') {
        arr.push(pendingPennyDropCard);
      }
    });
    return arr.map((item) => {
      return (
        <CarousalCard
          key={item.title}
          title={item.title}
          subtitle={item.subtitle}
          ctaLabel={item.ctaLabel}
          ctaLink={item.ctaLink}
          ctaClassName={item.ctaClassName}
          isImportant={item.isImportant}
          icon={item.icon}
          dashboardData={item.transactionData}
        />
      );
    });
  };

  public render() {
    const { transactionData } = this.props;
    return (
      <div>
        <div className="center mb30">
          {transactionData ? (
            <Fragment>
              <div className="mb30">{this.getCarousalCards()}</div>
              <DashboardCard dashboardData={transactionData} />
            </Fragment>
          ) : (
            <div className="text-center">
              <h1 className="heading text--xxxlg mobile-only--text--xxlg mb10">
                Investment Made Simple
              </h1>
              <p>
                By Cleartax, trusted by{' '}
                <span className="paint-bg">25 lakh Indians</span>
              </p>
              <br />
            </div>
          )}
        </div>
        <style jsx>
          {`
            .dasboard-preview {
              background-color: #ffffff;
              border: 1px solid #dae2ea;
              border-radius: 3px;
              box-shadow: 0 1px 5px 0 rgba(193, 205, 218, 0.21);
              width: 320px;
              height: 115px;
            }
            .tick-wrapper {
              padding: 10px 0;
              line-height: 16px;
              text-align: left;
              margin-left: 0px;
            }
            .tick-wrapper-p {
              margin-left: 15px;
              padding-left: 10px;
            }
            .tick-wrapper img {
              float: left;
              width: 18px;
              padding: left;
            }
            .paint-bg {
              background: url('https://assets1.cleartax-cdn.com/clearsave/images/highlight.svg');
              background-repeat: no-repeat;
              background-position: 0;
              background-position-x: 0px;
              background-position-y: center;
              background-size: contain;
              font-weight: 700;
              padding: 0 5px;
              display: inline-block;
              font-size: 20px;
            }
            @media screen and (max-width: 414px) {
              .content-box {
                float: none;
              }
              .image {
                height: 103px;
              }
              .image1 {
                height: 103px;
                padding-left: 50px;
              }

              .custom-margin {
                margin-top: 21px;
                padding-top: 2px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default BannerOne;



// WEBPACK FOOTER //
// ./components/homePage/experimental/bannerOne.tsx